import clsx from 'clsx';
import { times } from 'es-toolkit/compat';
import { Skeleton, SkeletonBlock, SkeletonText } from '@_/ui';

interface VenueListSkeletonProps {
  numColumns?: 2 | 3 | 4;
}

export function VenueListSkeleton({ numColumns = 2 }: VenueListSkeletonProps) {
  const numItems = Math.max(2, numColumns);

  return (
    <div
      className={clsx(
        'flex flex-col gap-6 sm:grid sm:gap-8',
        numColumns === 2 && 'sm:grid-cols-2',
        numColumns === 3 && 'sm:grid-cols-2 md:grid-cols-3',
        numColumns === 4 && 'sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
      )}
    >
      {times(numItems, i => i + 1).map(col => (
        <VenueListItemSkeleton key={col} />
      ))}
    </div>
  );
}

function VenueListItemSkeleton() {
  return (
    <Skeleton className="flex gap-x-3 sm:block sm:gap-0">
      <SkeletonBlock className="aspect-[4/3] w-24 flex-none rounded-lg sm:w-full" />
      <div className="w-full sm:mt-3">
        <SkeletonText className="w-full max-w-48 sm:max-w-64" />
        <SkeletonText className="w-full max-w-24" />
        <SkeletonText className="w-full max-w-32 sm:hidden" />
      </div>
    </Skeleton>
  );
}
